import { createFileRoute } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { getRecitalOptions } from '~entities/recital-manager/api/get-recital';

export const Route = createFileRoute('/_auth/_layout/recitals/$recitalId')({
  loader: async ({ params }) => {
    const options = getRecitalOptions(params.recitalId);
    await queryClient.ensureQueryData(options);
  },
});
